var map = {
	"./chlg-logo-default.png": "d60c",
	"./chlg-soccer-logo-default.png": "f6c3",
	"./currie-cup-logo-default.png": "4582",
	"./cwc-logo-default.png": "9402",
	"./epl-logo-default.png": "cb33",
	"./epl-soccer-logo-default.png": "690a",
	"./euro-logo-default.png": "0d82",
	"./european-championship-2024-logo-default.png": "c72c",
	"./fifa-world-cup-logo-default.png": "6d73",
	"./icc-men's-cricket-world-cup-2023-logo-default.png": "92e4",
	"./icc-t20-world-cup-logo-default.png": "e7a0",
	"./natl-logo-default.png": "08d6",
	"./psl-soccer-logo-default.png": "1ad5",
	"./rugby-union-world-cup-logo-default.png": "fd02",
	"./rwc-logo-default.png": "d0d0",
	"./sa-20-league-2024-logo-default.png": "663f",
	"./sad-logo-default.png": "14b7",
	"./safr-logo-default.png": "c638",
	"./t20-cup-logo-default.png": "aca8",
	"./united-rugby-championship-logo-default.png": "41ee",
	"./urc-logo-default.png": "bafb",
	"./women's-world-cup-logo-default.png": "746c",
	"./wwc-logo-default.png": "0a71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "899e";